// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".history-menu-btn,.history-menu-list-wrap{-webkit-box-shadow:0 0 4px 0 #0764e924,0 4px 8px 0 #0764e914;box-shadow:0 0 4px 0 #0764e924,0 4px 8px 0 #0764e914}.history-menu-title,.history-menu-tooltip{border:1px solid #dfe1e6!important;margin-bottom:4px!important;-webkit-box-shadow:0 2px 6px 0 #00000014;box-shadow:0 2px 6px 0 #00000014}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
